import emailjs from "@emailjs/browser";

export const EMAIL_TEMPLATE_IDS = {
  contact: String(process.env.GATSBY_EMAILJS_CONTACT_TEMPLATE_ID),
};

type SendEmailData = {
  templateId: string;
  params: Record<string, string>;
};

export const sendEmail = async (data: SendEmailData) => {
  const { params, templateId } = data;

  return emailjs.send(
    String(process.env.GATSBY_EMAILJS_SERVICE_ID),
    templateId,
    params,
    String(process.env.GATSBY_EMAILJS_KEY),
  );
};
